import React from 'react'
import { FloatingWhatsApp } from 'react-floating-whatsapp';

function WhatsappButton() {
  return (
    <div >
        <FloatingWhatsApp 
        phoneNumber= "97143981777"
        accountName='AL GHAITH PROPERTIES'
        avatar= 'images/logowhtbg.png'
        statusMessage='Welcome To AL GHAITH PROPERTIES'
        chatMessage='How can we assist today?'
        placeholder='Type your message here'
        messageDelay={3}
        darkMode={false}
        allowClickAway={true}
        allowEsc={true}
        chatboxHeight={350}
        notification={false}
        notificationSound={true}
        notificationLoop={3}
        style={
          {
            position:"",
            bottom:"20px",
            right:"20px",
            

          }
        }
       />   
    </div>  

  )
}

export default WhatsappButton